<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">

					<div class="user_menu2">
						<div class="user_menu_div1">
							<div class="wp1" :class="{ 'active': menu_index == 1 }">
								<div class="ic">
									<img src="@/assets/image/order_ic2.png" />
								</div>
								<span>我的租赁订单</span>
							</div>
							<div class="user_menu_list">
								<div class="item" :class="{ 'active': menu_index == 1 && status == -1 }"
									@click="choseOrder(1, -1)">全部订单</div>
								<div class="item" :class="{ 'active': menu_index == 1 && status == 1 }"
									@click="choseOrder(1, 1)">进行中</div>
								<div class="item" :class="{ 'active': menu_index == 1 && status == 2 }"
									@click="choseOrder(1, 2)">已取消</div>
								<div class="item" :class="{ 'active': menu_index == 1 && status == 3 }"
									@click="choseOrder(1, 3)">交易完成</div>
							</div>
						</div>

						<div class="user_menu_div1">
							<div class="wp1" :class="{ 'active': menu_index == 2 }">
								<div class="ic"><img src="@/assets/image/order_ic.png" /></div>
								<span>我的出租订单</span>
							</div>
							<div class="user_menu_list">
								<div class="item" :class="{ 'active': menu_index == 2 && status == -1 }"
									@click="choseOrder(2, -1)">全部订单</div>
								<div class="item" :class="{ 'active': menu_index == 2 && status == 1 }"
									@click="choseOrder(2, 1)">进行中</div>
								<div class="item" :class="{ 'active': menu_index == 2 && status == 2 }"
									@click="choseOrder(2, 2)">已取消</div>
								<div class="item" :class="{ 'active': menu_index == 2 && status == 3 }"
									@click="choseOrder(2, 3)">交易完成</div>
							</div>
						</div>

					</div>
				</div>
				<div class="fr fr2">

					<div class="order_mobile_list" v-if="isMobile">
						<div class="item" v-for="(item, index) in list">
							<div class="text_1">
								<div class="sp1">编号 {{ item.id }}</div>
								<div class="sp2" v-if="item.is_sell != 2 && item.status == 'pulloff'">审核失败</div>
								<div class="sp2" v-if="item.is_sell != 2 && item.status == 'hidden'">待审核</div>
								<div class="sp2" v-if="item.is_sell == 2">已出售</div>
							</div>
							<div class="text_2">
								<div class="image">
									<img src="@/assets/image/tu_biao.png" />
								</div>
								<div class="text">
									<div class="p1">{{ item.archives.title }}</div>
									<div class="p2">
										<div class="item_text">
											<span class="sp1">创建时间:</span>
											<span class="sp2">{{ item.createtime }}</span>
										</div>
										<div class="item_text">
											<span class="sp1">备注:</span>
											<span class="sp2">{{ item.beizhu }}</span>
										</div>
									</div>
									<div class="p2">
										<div class="item_text">
											<span class="sp1">售价:</span>
											<span class="sp2">{{ item.price }}元</span>
										</div>
										<div class="item_text">
											<span class="sp1">区服:</span>
											<span class="sp2">({{ item.qufu_text }})</span>
										</div>
									</div>
								</div>

							</div>

							<div class="text_3">
								<div class="con" v-if="item.is_sell == 0 && menu_index == 2">
									<span class="sp1" @click="xiajia(index, item)"
										v-if="item.status == 'normal'">下架</span>
									<span class="sp1" @click="shangjia(index, item)"
										v-if="item.status == 'pulloff'">上架</span>

									<router-link class="sp2" target="_blank"
										:to="{ path: '/sell', query: { id: item.id } }">
										编辑
									</router-link>
								</div>
								<div class="con" v-if="menu_index == 1">
									<span class="sp1" v-if="item.status == '0'"
											@click="payOrderGo(item.id)">去支付</span>
									<span class="sp2" v-if="item.status == '0'"
											@click="cancel(item.id)">取消</span>
								</div>

								
								
							</div>
						</div>
					</div>

					<div class="my_goods_list" v-if="!isMobile">
						<div class="item" v-for="(item, index) in list">
							<div class="con1">
								<div class="text_1">

									<div class="sp2">订单编号:{{ item.order_no }}</div>
									<div class="sp3">复制</div>
								</div>
							</div>
							<div class="con2">
								<div class="text_1">
									<div class="image">
										<img src="@/assets/image/tu_biao.png" />
									</div>
									<div class="text">
										<div class="p1">
											{{ item.archives.title }}</div>
										<div class="p2">
											<div class="item_text">
												<span class="sp1">下单时间:</span>
												<span class="sp2">{{ item.createtime }}</span>
											</div>
											<div class="item_text">
												<span class="sp1">备注:</span>
												<span class="sp2">{{ item.beizhu }}</span>
											</div>
										</div>
										<div class="p2">
											<div class="item_text">
												<span class="sp1">订单金额:</span>
												<span class="sp2">{{ item.price }}元</span>
											</div>
											<!-- <div class="item_text">
												<span class="sp1">游戏区服:</span>
												<span class="sp2">三角洲行动(QQ)</span>
											</div> -->
										</div>
									</div>
								</div>
								<div class="text_2">
									<div class="con" v-if="menu_index == 1">
										<span class="sp1" v-if="item.status == '0'"
											@click="payOrderGo(item.id)">去支付</span>
										<span class="sp2" v-if="item.status == '0'"
											@click="cancel(item.id)">取消</span>
										<!-- <span class="sp2">编辑</span> -->
									</div>


									<div class="con" v-if="item.is_sell == 0 && menu_index == 2">
										<span class="sp1" @click="xiajia(index, item)"
											v-if="item.status == 'normal'">下架</span>
										<span class="sp1" @click="shangjia(index, item)"
											v-if="item.status == 'pulloff'">上架</span>

										<router-link class="sp2" target="_blank"
											:to="{ path: '/sell', query: { id: item.id } }">
											编辑
										</router-link>
									</div>


								</div>
							</div>
						</div>
					</div>

					<el-empty description="暂无数据" v-if="list.length == 0"></el-empty>

					<el-pagination class="pagebox" v-if="list.length > 0 && !isMobile" background @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
					<el-pagination class="pagebox" v-if="list.length > 0 && isMobile" background @size-change="handleSizeChange"
						@current-change="handleCurrentChange" :current-page="current_page"
						:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
						layout="total, prev, pager, next" :total="total">
					</el-pagination>

				</div>
			</div>
		</div>


		<el-dialog :visible.sync="payvisible" :center="true" custom-class="pay_dialog" title="收银台" width="544px"
			destroy-on-close @closed="payvisible = false">
			<div class="pay_dialog_page">
				<div class="scan_operat">
					<div class="scan_area" v-if="pay_type == 1">
						<p class="scan_area_title">请打开支付宝扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk">
							<el-statistic format="mm:ss" :value="pay_info.expiretime * 1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_area" v-if="pay_type == 2">
						<p class="scan_area_title">请打开微信扫一扫</p>
						<div class="qr-box">
							<div ref="qrcode" id="qrcodePay" style="display: inline-block;">


							</div>

						</div>
						<p class="pay_risk" style="display: none;">订单已超时取消，请重新下单</p>
						<div class="pay_risk" v-if="pay_show">
							<el-statistic format="mm:ss" :value="pay_info.expiretime * 1000" time-indices title="">
							</el-statistic>
							后二维码失效
						</div>
					</div>
					<div class="scan_control">
						<p class="scan_control_price">
							应付金额：
							<span>¥{{ pay_info.price }}</span>
						</p>
						<div class="scan_control_option" @click="openPay(1)">
							<div>

								<img :src="require(`@/assets/image/alipay.png`)" alt="ALIPAY">
								<span>支付宝</span>
							</div> <img v-if="pay_type == 1" :src="require(`@/assets/image/radio_icon_active.png`)"
								alt="选择支付方式" class="option_single_choice">
							<img v-if="pay_type != 1" :src="require(`@/assets/image/radio_icon.png`)" alt="选择支付方式"
								class="option_single_choice">

						</div>
						<!-- <div class="scan_control_option" @click="openPay(2)">
							<div>
								<img :src="require(`@/assets/image/wechat.png`)" alt="wechat">
								<span>微信支付</span>
							</div> <img v-if="pay_type == 2" :src="require(`@/assets/image/radio_icon_active.png`)"
								alt="选择支付方式" class="option_single_choice">
							<img v-if="pay_type != 2" :src="require(`@/assets/image/radio_icon.png`)" alt="选择支付方式"
								class="option_single_choice">
						</div> -->

						<p class="scan_control_tips">为确保您当前交易的安全，扫描二维码后会进行安全验证！</p>
					</div>
				</div>
			</div>
		</el-dialog>


	</div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
	Notification,
	Message
} from 'element-ui'
import moment from 'moment';
export default {
	components: {
		usermenu
	},
	data() {
		return {
			status: -1,

			list: [],
			current_page: 1,
			pagesize: 10,
			total: 0,
			last_page: 0,
			menu_index: 1,
			payvisible: false,
			pay_info: {},
			pay_type: 1,
			order_id: 0,
			pay_show: false



		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		},
		login() {
			return this.$store.getters.login
		},
		open_login() {
			return this.$store.getters.open_login
		},

		isMobile() {
			return this.$store.getters.isMobile
		},
		gamelist() {
			return this.$store.getters.gamelist
		},
		allGameList() {
			return this.$store.getters.allGameList
		},
		config() {
			return this.$store.getters.config
		},
	},
	created: function (data) {

		this.current_page = 1;
		this.pagesize = 10;
		this.addRandomData(this.current_page);


	},
	watch: {
		$route() {

		}
	},
	methods: {
		cancel(id,index) {
			var that = this;
			this.rq.requests.post("api/game/order/cancel", {
				id: id,
			}).then(res => {
				if (res.code == 1) {
					Message.success({
						message: "取消成功",
						duration: 3000
					})
					location.reload()
				} else {
					Message.error({
						message: res.msg,
						duration: 3000,
					})
				}


			}).catch(error => {

			})
		},

		payOrderGo(item){
			var that = this
			if(!this.isMobile){
				that.payOrder(item)
			}else{
				that.payOrderMobile(item)
			}
		},
		payOrderMobile(id) {
			var that = this;
			this.rq.requests.post("api/game/Order/payOrder2", {
				id: id,
				pay_type: this.pay_type
			}).then(res => {
				if (res.code == 1) {
					open('http://api.kkzh.com/index/index/alipay?id='+res.data.id)
				}
			}).catch(res => {
				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},
		payOrder(item) {
			var id = item
			var that = this;
			this.rq.requests.post("api/game/Order/payOrder", {
				id: id,
				pay_type: this.pay_type
			}).then(res => {
				if (res.code == 1) {
					that.pay_show = false
					open('http://api.kkzh.com/index/index/alipay?id='+res.data.id)
					return;
					that.payvisible = true
					that.pay_info = res.data
					that.pay_show = true
					setTimeout(function () {
						var qrcodeElement = document.getElementById("qrcodePay");
						qrcodeElement.innerHTML = "";
						if (that.pay_type == 1) {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.qr_code,
								width: 130,
								height: 130
							});

						}

						if (that.pay_type == 2) {
							new QRCode(document.getElementById("qrcodePay"), {
								text: that.pay_info.pay.code_url,
								width: 130,
								height: 130
							});
						}


					}, 500);

					const intervalId = setInterval(() => {
						this.rq.requests.post("api/game/order/detail", {
							id: id,
						}).then(res => {
							if (res.data.status == '1') {
								clearInterval(intervalId);
								that.$router.push("/order")
							}
						}).catch(error => {
							clearInterval(intervalId);
						})
					}, 5000);
				}
			}).catch(res => {
				Message.error({
					message: res.msg,
					duration: 3000,
					offset: "580"
				})
			})
		},
		choseOrder(index, status) {
			this.menu_index = index
			this.status = status
			this.current_page = 1;
			this.pagesize = 10;
			this.addRandomData(this.current_page);
		},


		handleSizeChange(val) {

			this.pagesize = val;
			this.addRandomData(this.current_page);
		},
		handleCurrentChange(val) {
			this.current_page = val;
			this.addRandomData(this.current_page);
		},

		addRandomData(current_page) {
			this.loading = true;
			var that = this;
			this.list = []




			this.rq.requests.post("api/game/order/mylist", {
				menu_index: that.menu_index,
				status: that.status,
				page: current_page,
				pagesize: that.pagesize,
			}).then(res => {
				that.last_page = res.data.last_page;
				that.current_page = res.data.current_page;
				that.total = res.data.total;


				that.list = res.data.data;
				that.loading = false


			}).catch(error => {

			})
		},


	}


}
</script>